export default "<div>\n    <p>Page not found</p>\n\n</div>"